import type { StageKey } from './types';

export const stages: Record<StageKey, { color: string }> = {
    abertura: { color: '#7c8d96' },
    pendente: { color: '#3b82c4' },
    pre: { color: '#23939f' },
    analise: { color: '#7466cf' },
    corrigir: { color: '#d99a1e' },
    reprovado: { color: '#d23b3b' },
    creditado: { color: '#2f9e6e' },
};

export const openStages: StageKey[] = ['abertura', 'pendente', 'pre', 'analise', 'corrigir'];
export const doneStages: StageKey[] = ['reprovado', 'creditado'];
export const allStages: StageKey[] = [...openStages, ...doneStages];

export const formatCurrency = (value: number) => value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const formatDate = (value?: string | null) => {
    if (!value) {
        return '—';
    }

    const date = new Date(value.includes('T') ? value : `${value}T12:00:00`);
    return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString('pt-BR');
};
